import React from 'react';

interface IAgent {
  fill?: string;
  width?: string;
  height?: string;
}

const Agent = ({
  fill = 'var(--PRIMARY)',
  width = '32',
  height = '32',
}: IAgent) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 6.33324C16.5538 6.33324 17.0952 6.49746 17.5556 6.80513C18.0161 7.1128 18.375 7.5501 18.5869 8.06173C18.7988 8.57336 18.8543 9.13635 18.7462 9.6795C18.6382 10.2226 18.3715 10.7216 17.9799 11.1131C17.5884 11.5047 17.0894 11.7714 16.5463 11.8794C16.0031 11.9875 15.4402 11.932 14.9285 11.7201C14.4169 11.5082 13.9796 11.1493 13.6719 10.6888C13.3643 10.2284 13.2 9.68703 13.2 9.13324C13.2 8.39064 13.495 7.67845 14.0201 7.15334C14.5452 6.62824 15.2574 6.33324 16 6.33324ZM16 18.3999C20 18.3999 24.1334 20.2799 24.1334 21.1332V22.6666H7.86671V21.1999C7.86671 20.3466 12.04 18.3999 16 18.3999ZM16 3.86658C14.9452 3.86658 13.9141 4.17937 13.037 4.76541C12.1599 5.35144 11.4763 6.18439 11.0727 7.15893C10.669 8.13347 10.5634 9.20583 10.7692 10.2404C10.975 11.275 11.4829 12.2253 12.2288 12.9711C12.9747 13.717 13.925 14.225 14.9596 14.4308C15.9941 14.6366 17.0665 14.5309 18.041 14.1273C19.0156 13.7236 19.8485 13.04 20.4345 12.163C21.0206 11.2859 21.3334 10.2547 21.3334 9.19991C21.3422 8.49394 21.2108 7.79324 20.9467 7.13845C20.6826 6.48367 20.2912 5.88783 19.795 5.3855C19.2989 4.88317 18.708 4.48435 18.0565 4.21217C17.4051 3.93998 16.7061 3.86652 16 3.86658ZM16 15.8666C12.44 15.8666 5.33337 17.6532 5.33337 21.1999V23.8666C5.33337 24.2202 5.47385 24.5593 5.7239 24.8094C5.97395 25.0594 6.31309 25.1999 6.66671 25.1999H25.3334C25.687 25.1999 26.0261 25.0594 26.2762 24.8094C26.5262 24.5593 26.6667 24.2202 26.6667 23.8666V21.1999C26.6667 17.5866 19.56 15.8666 16 15.8666Z"
      fill={fill}
    />
  </svg>
);

export default Agent;
